import ClinicalData from './clinical-data';

export default ClinicalData;
